<!--  -->
<template>
    <div>
        <div class="invoice-header flex align-center justify-between" :class="isFixed ? 'fixed' : ''">
            <slot name="left"></slot>
            <div class="invoice-date flex align-center" @click="showDatePick = true">
                <span v-if="$props.type.indexOf('year') != -1 || $props.type == 'date'">{{ year }}年</span>
                <van-icon v-if="$props.type.indexOf('year') != -1" name="arrow-down" />

                <span v-if="$props.type.indexOf('month') != -1 || $props.type == 'date'">{{ month }}月</span>
                <van-icon v-if="$props.type.indexOf('month') != -1" name="arrow-down" />

                <span v-if="$props.type.indexOf('day') != -1 || $props.type == 'date'"> {{ day }}日</span>
                <van-icon v-if="$props.type.indexOf('day') != -1 || $props.type == 'date'" name="arrow-down" />
            </div>
            <slot name="right"></slot>
        </div>

        <!-- 选择时间 -->
        <van-action-sheet v-model="showDatePick">
            <div class="content">
                <van-datetime-picker v-model="currentDate" :type="type" :formatter="formatter" @cancel="showDatePick = false" @confirm="getPickDate" v-bind="$attrs" />
            </div>
        </van-action-sheet>
    </div>
</template>

<script>
import { one2two } from "@/libs/tools";

export default {
    name: "DatePicker",
    props: {
        date: {
            type: String,
            default: "",
        },
        type: {
            type: String,
            default: "year-month",
        },
        //是否固定位置
        isFixed: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            year: "",
            month: "",
            day: "",
            showDatePick: false,
            currentDate: new Date(),
        };
    },

    mounted() {
        this.getNowDate();
    },

    methods: {
        // 获取当前时间
        getNowDate() {
            let date = new Date();
            this.year = date.getFullYear();
            this.month = one2two(date.getMonth() + 1);
            let day = String(date.getDate());
            this.day = day.length == 1 ? "0" + day : day;

            this.getDate();
        },

        // 时间选择
        getPickDate(value) {
            this.year = value.getFullYear();
            this.month = one2two(value.getMonth() + 1);
            let day = String(value.getDate());
            this.day = day.length == 1 ? "0" + day : day;
            this.showDatePick = false;
            this.getDate();
            this.$emit("changeDate", value);
        },
        //时间格式拼接
        getDate() {
            let str = "";
            if (this.type.indexOf("year") != -1) {
                str += this.year;
            } else if (this.type == "date") {
                str += this.year;
            }
            if (this.type.indexOf("month") != -1) {
                str += `-${this.month}`;
            } else if (this.type == "date") {
                str += `-${this.month}`;
            }
            if (this.type.indexOf("day") != -1) {
                str += `-${this.day}`;
            } else if (this.type == "date") {
                str += `-${this.day}`;
            }

            this.$emit("update:date", str);
        },

        formatter(type, val) {
            if (type === "year") {
                return `${val}年`;
            }
            if (type === "month") {
                return `${val}月`;
            } else if (type === "day") {
                return `${val}日`;
            }
            return val;
        },
    },
};
</script>
<style lang="less" scoped>
@import "~@/assets/style/color.less";

.fixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
}
.invoice-header {
    width: 750px;
    height: 90px;
    padding: 30px;

    background-color: #fff;

    .invoice-date {
        font-size: 28px;
        color: #666666;

        i {
            margin: 0 4px;
        }
    }
    .invoice-header-cancle {
        margin-left: 30px;
        img {
            width: 32px;
            height: 32px;
            margin-right: 15px;
        }
    }
    .invoice-header-batch {
        margin-left: 30px;
        color: @main-color;
        img {
            width: 32px;
            height: 32px;
            margin-right: 15px;
        }
    }
}
</style>
